import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSignupJobSearchStatusFilter } from './useSignupJobSearchStatusFilter';

export const SignupJobSearchStatusFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, jobSearchStatusOptions } = useSignupJobSearchStatusFilter({ setFilters });

  return (
    <Formik
      initialValues={{ signupJobSearchStatuses: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="signupJobSearchStatuses"
          label="Job search status"
          placeholder="Add..."
          size="small"
          component={FormMultiSelect}
          options={jobSearchStatusOptions}
          anchorToBody
          isSearchable={false}
        />
      </Form>
    </Formik>
  );
};

SignupJobSearchStatusFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SignupJobSearchStatusFilter.defaultProps = {
  value: [],
};
